/**
 * Lookup data used in dropdowns for species, ports, gear types...
 */
export class LookupItem {

  // What list this item belongs to
  lookupType: string = '';

  // ID, unique identifier?
  id: number = 0;

  // For ports and species primarily
  code: string = '';
 
  // The actual value
  name: string = '';

  // The date this item is valid from
  activeDate: string = '';


  constructor(value: string, id: number = 0, type: string = '') {
      this.name = value;
      this.id = id;
      this.lookupType = type;
  }

  // transform anon into a lookup item
  static transformAnonymous(anon: any): LookupItem {
    if (!anon) return new LookupItem('', 0);
    let li = new LookupItem(anon.name, anon.id);
    li.lookupType = anon.lookupType;
    li.code = anon.code;
    li.activeDate = anon.activeDate;
    return li;
  }

  // transform an array into a lookup item array
  static transformAnonymousArr(anonArr: any[]): LookupItem[] {
    let list: LookupItem[] = [];
    anonArr.forEach((anon: any) => {
      list.push(this.transformAnonymous(anon));
    });
    return list;
  }

  isEqual(cmp: LookupItem) {
    return this.lookupType == cmp.lookupType && this.id == cmp.id;
  }

  toLowerCase(): string {
    return this.name.toLowerCase();
  } 

  toString(): string {
    return this.name;
  }
}
